const discountTagSvg = `<svg width="165" height="165" viewBox="0 0 165 165" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.03136 91.5103L37.2188 119.698C40.4241 122.903 44.7606 124.713 49.2857 124.713L115.653 124.713C125.081 124.713 132.717 117.077 132.717 107.65V57.3083C132.717 47.881 125.081 40.245 115.653 40.245L49.2857 40.245C44.7606 40.245 40.4241 42.055 37.2188 45.2603L9.05022 73.4289C4.03492 78.4064 4.03493 86.5139 9.03136 91.5103ZM36.1818 76.4267C37.782 74.8266 39.9523 73.9276 42.2153 73.9276C44.4782 73.9276 46.6485 74.8266 48.2487 76.4267C49.8489 78.0269 50.7478 80.1972 50.7478 82.4602C50.7478 84.7231 49.8489 86.8934 48.2487 88.4936C46.6485 90.0938 44.4782 90.9927 42.2153 90.9927C39.9523 90.9927 37.782 90.0938 36.1818 88.4936C34.5817 86.8934 33.6827 84.7231 33.6827 82.4602C33.6827 80.1972 34.5817 78.0269 36.1818 76.4267Z" fill="#FFC700"/>
      <path d="M68.9359 57.66L70.9759 57.66L70.9759 65.7C70.9759 66.74 71.1159 67.5067 71.3959 68C71.6226 68.3733 71.9559 68.7 72.3959 68.98C72.8359 69.2467 73.3293 69.38 73.8759 69.38C74.4226 69.38 74.9159 69.2467 75.3559 68.98C75.7959 68.7 76.1293 68.3733 76.3559 68C76.6359 67.5067 76.7759 66.74 76.7759 65.7L76.7759 57.66L78.8159 57.66L78.8159 66.24C78.8159 67.64 78.4026 68.7933 77.5759 69.7C76.6159 70.74 75.3826 71.26 73.8759 71.26C72.3693 71.26 71.1359 70.74 70.1759 69.7C69.3493 68.7933 68.9359 67.64 68.9359 66.24L68.9359 57.66ZM82.0219 57.66L84.9619 57.66C86.1885 57.66 87.1619 57.9 87.8819 58.38C88.4152 58.74 88.8219 59.2133 89.1019 59.8C89.3952 60.3733 89.5419 60.98 89.5419 61.62C89.5419 62.82 89.1085 63.7933 88.2419 64.54C87.4285 65.2333 86.3419 65.58 84.9819 65.58L84.0619 65.58L84.0619 71L82.0219 71L82.0219 57.66ZM84.0619 59.54L84.0619 63.7L84.9819 63.7C85.8352 63.7 86.4819 63.5133 86.9219 63.14C87.3619 62.7533 87.5819 62.24 87.5819 61.6C87.5819 61.3733 87.5485 61.16 87.4819 60.96C87.4285 60.76 87.3152 60.5467 87.1419 60.32C86.9819 60.08 86.7152 59.8933 86.3419 59.76C85.9685 59.6133 85.5085 59.54 84.9619 59.54L84.0619 59.54ZM103.059 59.58L99.9992 59.58L99.9992 71L97.9592 71L97.9592 59.58L94.8992 59.58L94.8992 57.66L103.059 57.66L103.059 59.58ZM105.803 59.4C107.123 58.08 108.777 57.42 110.763 57.42C112.75 57.42 114.403 58.08 115.723 59.4C117.043 60.72 117.703 62.3667 117.703 64.34C117.703 66.3133 117.043 67.96 115.723 69.28C114.403 70.6 112.75 71.26 110.763 71.26C108.777 71.26 107.123 70.6 105.803 69.28C104.483 67.96 103.823 66.3133 103.823 64.34C103.823 62.3667 104.483 60.72 105.803 59.4ZM107.243 67.98C108.163 68.9133 109.337 69.38 110.763 69.38C112.19 69.38 113.363 68.9133 114.283 67.98C115.203 67.0333 115.663 65.82 115.663 64.34C115.663 62.86 115.203 61.6533 114.283 60.72C113.363 59.7733 112.19 59.3 110.763 59.3C109.337 59.3 108.163 59.7733 107.243 60.72C106.323 61.6533 105.863 62.86 105.863 64.34C105.863 65.82 106.323 67.0333 107.243 67.98Z" fill="black"/>
      <path d="M62.141 89.721L56.665 89.721C56.9117 87.427 57.7257 85.5647 59.107 84.134C60.6117 82.58 62.696 81.803 65.36 81.803C68.2213 81.803 70.3797 82.5307 71.835 83.986C73.093 85.1947 73.722 86.872 73.722 89.018C73.722 90.35 73.389 91.4723 72.723 92.385C72.2543 93.051 71.6377 93.569 70.873 93.939C72.1063 94.383 73.0437 95.049 73.685 95.937C74.4497 96.973 74.832 98.268 74.832 99.822C74.832 102.067 74.0057 103.941 72.353 105.446C70.7743 106.877 68.6037 107.592 65.841 107.592C62.733 107.592 60.328 106.741 58.626 105.039C57.0473 103.436 56.1347 101.401 55.888 98.934L61.586 98.934C61.6847 100.093 62.0793 101.018 62.77 101.709C63.436 102.375 64.3487 102.708 65.508 102.708C66.544 102.708 67.3703 102.424 67.987 101.857C68.653 101.24 68.986 100.402 68.986 99.341C68.986 98.3543 68.6283 97.565 67.913 96.973C67.247 96.455 66.2357 96.196 64.879 96.196L64.435 96.196L64.435 92.274L64.768 92.274C65.8533 92.274 66.6797 92.0397 67.247 91.571C67.8637 91.053 68.172 90.313 68.172 89.351C68.172 88.5123 67.9007 87.8463 67.358 87.353C66.8153 86.8597 66.1123 86.613 65.249 86.613C64.3117 86.613 63.5717 86.8843 63.029 87.427C62.4863 88.019 62.1903 88.7837 62.141 89.721ZM98.4235 94.679C98.4235 99.2177 97.2395 102.659 94.8715 105.002C93.1202 106.704 90.9125 107.555 88.2485 107.555C85.6339 107.555 83.4509 106.704 81.6995 105.002C79.3315 102.659 78.1475 99.2177 78.1475 94.679C78.1475 90.0663 79.3315 86.613 81.6995 84.319C83.4509 82.617 85.6339 81.766 88.2485 81.766C90.9125 81.766 93.1202 82.617 94.8715 84.319C97.2395 86.613 98.4235 90.0663 98.4235 94.679ZM90.5795 87.575C89.9382 86.9583 89.1735 86.65 88.2855 86.65C87.3975 86.65 86.6329 86.9583 85.9915 87.575C84.6102 88.9317 83.9195 91.2873 83.9195 94.642C83.9195 98.0213 84.6102 100.389 85.9915 101.746C86.6329 102.363 87.3975 102.671 88.2855 102.671C89.1735 102.671 89.9382 102.363 90.5795 101.746C91.9609 100.389 92.6515 98.0213 92.6515 94.642C92.6515 91.2873 91.9609 88.9317 90.5795 87.575ZM106.216 106.926L120.683 81.914L123.273 82.469L108.769 107.518L106.216 106.926ZM109.065 85.836C108.547 85.2687 107.844 84.985 106.956 84.985C106.068 84.985 105.365 85.2687 104.847 85.836C104.304 86.3787 104.033 87.094 104.033 87.982C104.033 88.87 104.304 89.5853 104.847 90.128C105.365 90.6953 106.068 90.979 106.956 90.979C107.844 90.979 108.547 90.6953 109.065 90.128C109.608 89.5853 109.879 88.87 109.879 87.982C109.879 87.094 109.608 86.3787 109.065 85.836ZM111.84 83.838C112.901 84.8987 113.431 86.28 113.431 87.982C113.431 89.684 112.901 91.0653 111.84 92.126C110.656 93.3593 109.028 93.976 106.956 93.976C104.884 93.976 103.256 93.3593 102.072 92.126C101.011 91.0653 100.481 89.684 100.481 87.982C100.481 86.28 101.011 84.8987 102.072 83.838C103.256 82.6047 104.884 81.988 106.956 81.988C109.028 81.988 110.656 82.6047 111.84 83.838ZM124.605 99.193C124.087 98.6257 123.384 98.342 122.496 98.342C121.608 98.342 120.905 98.6257 120.387 99.193C119.844 99.7357 119.573 100.451 119.573 101.339C119.573 102.227 119.844 102.942 120.387 103.485C120.905 104.052 121.608 104.336 122.496 104.336C123.384 104.336 124.087 104.052 124.605 103.485C125.148 102.942 125.419 102.227 125.419 101.339C125.419 100.451 125.148 99.7357 124.605 99.193ZM127.38 97.195C128.441 98.2557 128.971 99.637 128.971 101.339C128.971 103.041 128.441 104.422 127.38 105.483C126.196 106.716 124.568 107.333 122.496 107.333C120.424 107.333 118.796 106.716 117.612 105.483C116.551 104.422 116.021 103.041 116.021 101.339C116.021 99.637 116.551 98.2557 117.612 97.195C118.796 95.9617 120.424 95.345 122.496 95.345C124.568 95.345 126.196 95.9617 127.38 97.195Z" fill="black"/>
      </svg>`;

const blocks = [
  {
    label: "new-arrivals",
    title: "Shop New Arrivals",
    ctaLabel: "Shop Now",
    url: "/collections/new-arrivals",
    imageUrl:
      "https://cdn.shopify.com/s/files/1/0039/7079/3521/files/collection_block_new_arrivals.jpg?v=1715420411",
    hasDiscountTag: false,
  },
  {
    label: "clearance",
    title: "See Clearance Rack",
    ctaLabel: "Shop Now",
    url: "/collections/clearance",
    imageUrl:
      "https://cdn.shopify.com/s/files/1/0039/7079/3521/files/collection_block_clearance.png?v=1715420411",
    hasDiscountTag: true,
  },
  {
    label: "best-sellers",
    title: "See The Best Sellers",
    ctaLabel: "Shop Now",
    url: "/collections/bestsellers",
    imageUrl:
      "https://cdn.shopify.com/s/files/1/0039/7079/3521/files/collection_block_best_sellers.png?v=1715420411",
    hasDiscountTag: false,
  },
  {
    label: "full-collection",
    title: "See Full Collection",
    ctaLabel: "Shop Now",
    url: "/collections/all",
    imageUrl:
      "https://cdn.shopify.com/s/files/1/0039/7079/3521/files/collection_block_full_collection.png?v=1715420411",
    hasDiscountTag: false,
  },
  {
    label: "meggings", // Probably need to change this to meggings
    title: "See Meggings",
    ctaLabel: "Shop Now",
    url: "/collections/all",
    imageUrl:
      "https://cdn.shopify.com/s/files/1/0039/7079/3521/files/collection_block_full_collection.png?v=1715420411",
    hasDiscountTag: false,
  },
  {
    label: "solids",
    title: "See Solids Collection",
    ctaLabel: "Shop Now",
    url: "/collections/solid-colors",
    imageUrl:
      "https://cdn.shopify.com/s/files/1/0039/7079/3521/files/collection_block_solids.png?v=1715420411",
    hasDiscountTag: false,
  },
  {
    label: "prints",
    title: "See Prints Collection",
    ctaLabel: "Shop Now",
    url: "/collections/prints-collection",
    imageUrl:
      "https://cdn.shopify.com/s/files/1/0039/7079/3521/files/collection_block_prints.png?v=1715420412",
    hasDiscountTag: false,
  },
  {
    label: "tops",
    title: "See Tops Collection",
    ctaLabel: "Shop Now",
    url: "/collections/tops",
    imageUrl:
      "https://cdn.shopify.com/s/files/1/0039/7079/3521/files/collection_block_tops.png?v=1715420412",
    hasDiscountTag: false,
  },
  {
    label: "shorts",
    title: "See Shorts Collection",
    ctaLabel: "Shop Now",
    url: "/collections/shorts",
    imageUrl:
      "https://cdn.shopify.com/s/files/1/0039/7079/3521/files/collection_block_shorts.png?v=1715420412",
    hasDiscountTag: false,
    imagePosition: "bottom center",
  },
];

const pages = [
  {
    url: "/collections/new-arrivals",
    repeats: false,
    every: 9,
    blocks: ["full-collection", "shorts", "tops"],
  },
  {
    url: "/collections/sale",
    repeats: false,
    every: 9,
    blocks: ["shorts", "tops", "full-collection"],
  },
  {
    url: "/collections/meggings",
    repeats: false,
    every: 9,
    blocks: ["clearance", "shorts", "tops"],
  },
  {
    url: "/collections/shorts",
    repeats: false,
    every: 9,
    blocks: ["tops", "clearance", "full-collection"],
  },
  {
    url: "/collections/tops",
    repeats: false,
    every: 9,
    blocks: ["shorts", "clearance", "full-collection"],
  },
  {
    url: "/collections/bestsellers",
    repeats: false,
    every: 9,
    blocks: ["shorts", "tops", "clearance"],
  },
  {
    url: "/collections/solid-colors",
    repeats: false,
    every: 9,
    blocks: ["prints", "clearance", "full-collection"],
  },
  {
    url: "/collections/prints-collection",
    repeats: false,
    every: 9,
    blocks: ["solids", "clearance", "full-collection"],
  },
  {
    url: "/collections/bike",
    repeats: false,
    every: 9,
    blocks: ["shorts", "tops", "full-collection"],
  },
  {
    url: "/collections/black-gray-collection",
    repeats: false,
    every: 9,
    blocks: ["shorts", "tops", "clearance"],
  },
  {
    url: "/collections/reverse-styles",
    repeats: false,
    every: 9,
    blocks: ["shorts", "tops", "clearance"],
  },
  {
    url: "/collections/camo-collection",
    repeats: false,
    every: 9,
    blocks: ["shorts", "tops", "clearance"],
  },
  {
    url: "/collections/pride-collection",
    repeats: false,
    every: 9,
    blocks: ["shorts", "tops", "clearance"],
  },
];

document.addEventListener("DOMContentLoaded", function () {
  // get url to check for pages
  const url = window.location.pathname;

  const page = pages.find((page) => page.url.includes(url));
  const collectionList = document.querySelector(".grid--collection");
  if (page && collectionList) {
    const firstChildsHeight = collectionList.children[0].offsetHeight + "px";
    if (page.every && !page.repeats && page.blocks) {
      const blocksToRepeat = blocks.filter((blk) =>
        page.blocks.includes(blk.label)
      );

      const itemsCount = collectionList.children.length;

      page.blocks.forEach((blockLabel, i) => {
        const blk = blocksToRepeat.find((blk) => blk.label === blockLabel);
        const block = collectionList.querySelector(
          `.grid__item:nth-child(${page.every * (i + 1)})`
        );
        if (blk && block) {
          block.insertAdjacentHTML(
            "beforebegin",
            generatePDPBlockHtmlTemplate(blk, firstChildsHeight)
          );
        }
      });

      if ([8, 16, 24].includes(itemsCount)) {
        // insert the last block
        const lastChild = collectionList.querySelector(
          `.grid__item:last-child`
        );
        const blk = blocksToRepeat.find(
          (blk) => blk.label === page.blocks[itemsCount / 8]
        );
        lastChild.insertAdjacentHTML(
          "afterend",
          generatePDPBlockHtmlTemplate(blk, firstChildsHeight)
        );
      }

      return;
    }
  }
});

function generatePDPBlockHtmlTemplate(blk, height) {
  const imagePosition = blk.imagePosition || "top center";

  if (blk.hasDiscountTag) {
    return `<div class="grid__item grid-product small--one-half medium-up--one-quarter aos-init aos-animate pdp-content-block__container" style="background-image: url(${
      blk.imageUrl
    }); height: ${height};">
    <div class="pdp-content-block__container-overlay"></div>
        ${discountTagSvg}
        <p>${blk.title
          .split(" ")
          .map((word) => `<span style="display: block;">${word}</span>`)
          .join("")}</p>
        <a href="${blk.url}" class="button">${blk.ctaLabel}</a>        
    </div>`;
  }

  return `<div class="grid__item grid-product small--one-half medium-up--one-quarter aos-init aos-animate pdp-content-block__container" style="background-image: url(${
    blk.imageUrl
  }); height: ${height}; background-position: ${imagePosition}">
  <div class="pdp-content-block__container-overlay"></div>
  <p>${blk.title
    .split(" ")
    .map((word) => `<span style="display: block;">${word}</span>`)
    .join("")}</p>
        <a href="${blk.url}" class="button">${blk.ctaLabel}</a>
    </div>`;
}
